//import { MbscModule } from '@mobiscroll/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MiniComponentsModule } from './mini-components/mini-components.module';
import { HeaderComponent } from './header/header.component';
import { SwipeComponent } from './swipe/swipe.component';
import { SearchSelectComponent } from './search-select/search-select.component';
import { ExpenseFilterComponent } from  './expense-filter/expense-filter.component';
import { CustomIonDatetimeComponent } from './custom-ion-datetime/custom-ion-datetime.component';
import { TimeExpenseDetailsComponent } from './time-expense-details/time-expense-details.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SwipeComponent,
    SearchSelectComponent,
    ExpenseFilterComponent,
    CustomIonDatetimeComponent,
    TimeExpenseDetailsComponent,
  ],
  imports: [
//    MbscModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MiniComponentsModule,
  ],
  exports: [
    HeaderComponent,
    SwipeComponent,
    MiniComponentsModule,
    SearchSelectComponent,
    ExpenseFilterComponent,
    CustomIonDatetimeComponent,
    TimeExpenseDetailsComponent,
  ],
})
export class ComponentsModule {}
